@if (shouldDisplayBanner() && bannerConfig(); as config) {
  <nz-alert
    class="custom-alert"
    nzType="info"
    [nzMessage]="bannerTpl"
    nzShowIcon
  />

  <ng-template #bannerTpl>
    <div class="custom-alert-inner">
      <div class="custom-alert-content">
        <div class="custom-alert-texts">
          <div class="custom-alert-title">
            {{ config.title }}
          </div>

          <div class="custom-alert-description">
            {{ config.message }}
          </div>
        </div>

        <span
          [nz-tooltip]="tooltip()"
          (click)="onRedirectUrl()"
        >
          <a
            class="custom-alert-button"
            [ngClass]="{'link-disabled': !isAuthorized()}"
          >
            {{ config.buttonLabel }}
          </a>
        </span>
      </div>
    </div>
  </ng-template>
}